import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "../Style/Password_warning.css";
import login_image from "../Images/Login-image.png";
import OTPInput from "../components/OTPInput";
import CountdownTimer from "../components/CountdownTimer";
import { validateOtp, initiatePasswordReset } from "../Services/authService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || "";

  const [otp, setOtp] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!email) {
      toast.warning("Email missing. Please request a password reset first.");
      navigate("/forgot-password", { replace: true });
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!otp || otp.length < 6) {
      setErrorMessage("Please enter the complete 6-digit OTP.");
      return;
    }

    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const response = await validateOtp(email, otp);
      const resetToken = response.data?.resetToken;

      if (!resetToken) {
        throw new Error("Reset token not provided by server.");
      }

      toast.success(response.message || "OTP verified successfully!");

      setTimeout(() => {
        navigate("/reset-password", {
          state: {
            email,
            resetToken,
          },
        });
      }, 1200);
    } catch (err) {
      setErrorMessage(err.message || "OTP validation failed.");
      toast.error(err.message || "OTP validation failed.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      const res = await initiatePasswordReset(email);
      toast.info(res.message || "A fresh OTP has been sent to your email.");
      setOtp("");
      setErrorMessage("");
    } catch (err) {
      toast.error(err.message || "Failed to resend OTP.");
      throw err;
    }
  };

  if (!email) return null;

  return (
    <>
      <Navbar />
      <div className="Login-form">
        <div className="login-image-container">
          <img src={login_image} alt="verify-otp" className="login-image" />
        </div>
        <form onSubmit={handleSubmit} className="form-container">
          <div className="contents">
            <span className="Login-heading">Enter Verification Code</span>
            <span className="Login-content">
              We have sent a 6-digit OTP code to <strong style={{ color: "#5e3bee" }}>{email}</strong>.
            </span>
          </div>

          <div className="login-form-main-container">
            <div className="login-form-content">
              <div className="form-group">
                <OTPInput
                  length={6}
                  value={otp}
                  onChange={(val) => {
                    setOtp(val);
                    if (errorMessage) setErrorMessage("");
                  }}
                  disabled={isSubmitting}
                />
                {errorMessage && (
                  <div
                    className="invalid-feedback"
                    style={{ display: "block", textAlign: "center", marginTop: "8px" }}
                  >
                    {errorMessage}
                  </div>
                )}
              </div>

              <CountdownTimer initialSeconds={30} onResend={handleResendOtp} disabled={isSubmitting} />
            </div>

            <div className="buttons buttons-2" style={{ marginTop: "24px" }}>
              <div className="form-group">
                <button
                  type="submit"
                  className="login-buttons"
                  disabled={isSubmitting || otp.length < 6}
                >
                  <div className="btn-content">
                    <span>{isSubmitting ? "Verifying..." : "Verify OTP"}</span>
                  </div>
                </button>
              </div>

              <div className="form-group" style={{ textAlign: "center", marginTop: "12px" }}>
                <Link
                  to="/forgot-password"
                  style={{ color: "#5e3bee", textDecoration: "none", fontSize: "14px", fontWeight: "500" }}
                >
                  ← Change Email Address
                </Link>
              </div>
            </div>
          </div>
        </form>
      </div>

      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
}
